import $ from "jquery";
import alertify from "alertifyjs";
import Swal from "sweetalert2";
import { baseUrl, apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure
const token = localStorage.getItem("access_token");

export async function favoriteQuestion(questionNo) {
  const response = await fetch(
    `${apiUrl}/qbanks/favourite-questions/${questionNo}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return await response.json();
}
